import React from 'react';
import config from '../../config';

window.SCORM_Values = [];

export const Spike = props => {
    // KEEP THIS LINE NO MATTER THE SPIKE
    //******************************************************** */
    if (!config.environment.indexOf('dev')) return null;
    //******************************************************** */
    return <div>{/* <iframe title="Spike" width="100%" height="700px" src={src} /> */}</div>;
};

export default Spike;
